<ng-container *transloco="let t">
  <ng-container *ngIf="(values$ | async) as values">

    <div class="row w-100 justify-content-start px-3" *ngFor="let v of values">

      <ng-container *ngIf="v.revoked">
        <div>
          <label>{{t('implicit-user-enablings-report.revoked')}}: </label>
          <span class="font-weight-bold">
            {{v.enablingId | enablingName | async}}
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="!v.revoked">
        <div>
          <label>{{t('implicit-user-enablings-report.enabling')}}: </label>
          <span class="font-weight-bold">
            {{v.enablingId | enablingName | async}}
          </span>
        </div>

        <div class="ml-3">
          <label>{{t('implicit-user-enablings-report.duration')}}: </label>
          <span class="font-weight-bold">
            {{v.duration | durationToString }}
          </span>
        </div>

        <div class="ml-3">
          <label>{{t('implicit-user-enablings-report.expiration')}}: </label>
          <span class="font-weight-bold">
            {{v.expiration | date:'dd/MM/yyyy HH:mm:ss'}}
          </span>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
